module.exports = __webpack_public_path__ + "static/media/an-individuals-self-determination-and-a-decentralised-team.4a244994.jpg";